import moment from 'moment';
import Configuracao from '../util/Configuracao';
import { SITUACAO_ALTERACAO_MINUTA } from './SituacaoAlteracaoMinuta';

/**
 * @see {@link http://doc.tst.jus.br/wiki/index.php/Sistema_de_Informa%C3%A7%C3%B5es_Judici%C3%A1rias_(Forms)#Sala_de_Sess.C3.A3o}
 */
class SituacaoAlteracaoMinutaBusiness {
    static getStatusMinuta(registro) {
        if (!registro) {
            return undefined;
        }

        if (registro.processo.origem === Configuracao.ORIGEM_SIJ) {
            if (SituacaoAlteracaoMinutaBusiness.isMinutaAnalisadaSIJ(registro)) {
                return {
                    id: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.id,
                    cor: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.cor,
                    texto: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.descricao,
                    analisado: true
                };
            }

            if (SituacaoAlteracaoMinutaBusiness.isEmentaEOuDecisaoAnalisadas(registro)) {
                return {
                    id: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_EMENTA_EOU_DECISAO_ANALISADAS.id,
                    cor: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_EMENTA_EOU_DECISAO_ANALISADAS.cor,
                    texto: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_EMENTA_EOU_DECISAO_ANALISADAS.descricao,
                    analisado: true
                };
            }

            if (SituacaoAlteracaoMinutaBusiness.isMinutaAlteradaSIJ(registro)) {
                return {
                    id: SITUACAO_ALTERACAO_MINUTA.ALTERADA.id,
                    cor: SITUACAO_ALTERACAO_MINUTA.ALTERADA.cor,
                    texto: SITUACAO_ALTERACAO_MINUTA.ALTERADA.descricao,
                    analisado: false,
                    onClickEnabled: true
                };
            }

            if (SituacaoAlteracaoMinutaBusiness.isEmentaEOuDecisaoAlteradas(registro)) {
                return {
                    id: SITUACAO_ALTERACAO_MINUTA.EMENTA_EOU_DECISAO_ALTERADAS.id,
                    cor: SITUACAO_ALTERACAO_MINUTA.EMENTA_EOU_DECISAO_ALTERADAS.cor,
                    texto: SITUACAO_ALTERACAO_MINUTA.EMENTA_EOU_DECISAO_ALTERADAS.descricao,
                    analisado: false,
                    onClickEnabled: true
                };
            }
        }

        if (registro.processo.origem === Configuracao.ORIGEM_PJE) {
            if (SituacaoAlteracaoMinutaBusiness.isMinutaAnalisadaPJe(registro)) {
                return {
                    id: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.id,
                    cor: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.cor,
                    texto: SITUACAO_ALTERACAO_MINUTA.ALTERACAO_ANALISADA.descricao,
                    analisado: true
                };
            }

            if (SituacaoAlteracaoMinutaBusiness.isMinutaAlteradaPJe(registro)) {
                return {
                    id: SITUACAO_ALTERACAO_MINUTA.ALTERADA.id,
                    cor: SITUACAO_ALTERACAO_MINUTA.ALTERADA.cor,
                    texto: SITUACAO_ALTERACAO_MINUTA.ALTERADA.descricao,
                    analisado: false,
                    onClickEnabled: true
                };
            }
        }

        return undefined;
    }

    static isMinutaAlterada(registro) {
        return registro.processo && registro.processo.origem === Configuracao.ORIGEM_PJE
            ? SituacaoAlteracaoMinutaBusiness.isMinutaAlteradaPJe(registro)
            : !SituacaoAlteracaoMinutaBusiness.isEmentaEOuDecisaoAlteradas(registro) &&
                  SituacaoAlteracaoMinutaBusiness.isMinutaAlteradaSIJ(registro);
    }

    static isMinutaAlteradaPJe(registro) {
        return (
            registro.dataAlteracaoMinuta &&
            !SituacaoAlteracaoMinutaBusiness.isDataAlteracaoMinutaAntesDaDataAnalise(registro)
        );
    }

    static isMinutaAnalisadaPJe(registro) {
        return (
            registro.dataAlteracaoMinuta &&
            SituacaoAlteracaoMinutaBusiness.isDataAlteracaoMinutaAntesDaDataAnalise(registro)
        );
    }

    static isDataAlteracaoMinutaAntesDaDataAnalise(registro) {
        return (
            registro.analiseMinuta &&
            registro.analiseMinuta.dataAnalise &&
            registro.dataAlteracaoMinuta &&
            moment(registro.dataAlteracaoMinuta, 'DD-MM-YYYY-HH-mm-ss').isBefore(
                moment(registro.analiseMinuta.dataAnalise, 'DD-MM-YYYY-HH-mm-ss')
            )
        );
    }

    static isMinutaAlteradaSIJ(registro) {
        return registro.informacaoProcessoSalaSessao && registro.informacaoProcessoSalaSessao.votoAlterado;
    }

    static isMinutaAnalisadaSIJ(registro) {
        return (
            registro.informacaoProcessoSalaSessao &&
            registro.informacaoProcessoSalaSessao.votoAlterado &&
            registro.informacaoProcessoSalaSessao.votoAnalisado
        );
    }

    static isEmentaEOuDecisaoAlteradas(registro) {
        return registro.informacaoProcessoSalaSessao && registro.informacaoProcessoSalaSessao.votoNulo;
    }

    static isEmentaEOuDecisaoAnalisadas(registro) {
        return (
            registro.informacaoProcessoSalaSessao &&
            registro.informacaoProcessoSalaSessao.votoNulo &&
            registro.informacaoProcessoSalaSessao.votoAnalisado
        );
    }
}

export default SituacaoAlteracaoMinutaBusiness;
